/**
 * main Data 관리 클래스
 * @category main
 * @memberof module:main
 * @param  {Object} _config={} 설정
 */
class DataStore {
	constructor(_config={}){
		this.data = {
			config: _config,
			Hotkeyword: _config.liveKeywords
		};
		this.apiUrlList = {
			Friend : this.data.config.apiDomain + '/web/v2/friends',
			Guild : this.data.config.apiDomain + '/game/v1/guild/members',
			Membership : this.data.config.apiDomain + '/web/v2/user/grade',
			//NshopRecommend : this.data.config.apiDomain + '/web/v2/nshop/goods/recommend',
			NshopToday : this.data.config.apiDomain + '/web/v2/nshop/goods/today',
			NshopMygodstone : this.data.config.apiDomain + '/web/v2/user/sinseok',
			NctvTitle : this.data.config.apiDomain + '/conti/getContent?service=NCTV&alias=bns-main-theme&lang=ko-KR',
			NctvList : this.data.config.nctvApiDomain + '/v1/videos/main?videoIds=',
			UserState : this.data.config.apiDomain + '/web/v2/user/state',
			UserIcafe : this.data.config.apiDomain + '/web/v2/user/icafe'
		};
	}

	/**
	 * @param  {String} _key='subsub'  요청할 데이터의 키네임
	 * @param  {Object} _param={} 요청시 추가할 파라미터 데이터
	 * @param  {Function} _callback=()=>{} 요청 완료후 데이터 전달할 콜백 함수...
	 * @category main
	 * @returns {Object} Json 데이타
	 * @example
	 * const appConfig = getData('sub1', {page: 1,per_page: 12}, this.render.bind(this));
	 */
	getData(_key = '', _param={}, _callback = ()=>{}){
		if( this.data[_key] ){
			_callback(this.data[_key]);
			return this.data[_key];
		}else{
			axios.get(this.apiUrlList[_key], {
				params: _param,
				withCredentials: true
			}).then( (response) => {
				this.data[_key] = response.data;
				_callback(response.data);
				return response.data;
			})
			.catch( (error, d) => {
				console.log('error: ', error.response);
				_callback(error.response);
				return error.response;

			});


		}
	}

	// Nshop
	getNshopData(_key = 'Nshop', _param={}, _callback = ()=>{}){

		if( this.data[_key] ){
			_callback(this.data[_key]);
			return this.data[_key];
		}else{

			this.data[_key] = {};
			//this.data[_key].NshopRecommend = {};
			this.data[_key].NshopToday = {};
			this.data[_key].NshopMygodstone = {};

			//let _api1 = this.apiUrlList['NshopRecommend'];
			let _api2 = this.apiUrlList['NshopToday'];
			let _api3 = this.apiUrlList['NshopMygodstone'];
			let _data = this.data[_key];

			// function axios1(_api1) {
			// 	return axios.get(_api1, {
			// 		params: _param
			// 	});
			// }
			function axios2(_api2) {
				return axios.get(_api2, {
					params: _param,
					withCredentials: true
				});
			}
			function axios3(_api3) {
				return axios.get(_api3, {
					params: _param,
					withCredentials: true
				});
			}

			function setData(data, data2, data3){

				//data.NshopRecommend = data1;
				data.NshopToday = data2;
				data.NshopMygodstone = data3;
				_callback( data );
				return data;
			}

      if(window._serviceEnv == 'SB'){
        _data = shopTestData;
        _callback( _data );
        return _data;
      }

			if (this.data.config.isLogin) {
				axios.all([axios2(_api2), axios3(_api3)])
					.then(axios.spread(function (res2, res3) {
						setData( _data, res2.data, res3.data);
					}));
			} else {
				axios.all([axios2(_api2)])
					.then(axios.spread(function ( res2) {
						setData( _data, res2.data, {count:0});
					}));
				$(".nshop-info > .count ").hide();
			}
		}
	}


	getNctvData(_key = 'Nctv', _param={}, _callback = ()=>{}){
		if( this.data[_key] ){
			_callback(this.data[_key]);
			return this.data[_key];
		}else{
			this.data[_key] = {};
			this.data[_key].NctvTitle = {};
			this.data[_key].NctvList = {};
			this.data[_key].NctvIds = {};
			this.data[_key].NctvListApi = this.apiUrlList['NctvList'];
			this.data['NctvList'] = {};

			axios.get(this.apiUrlList['NctvTitle'], {
				params: _param,
				headers : {
					'Content-Type': 'application/json'
				},
				data: {}
			}).then( (response) => {
				this.data['Nctv'].NctvTitle = JSON.parse(response.data.jsonData).themeArea;
				this.data['Nctv'].NctvIds = JSON.parse(response.data.jsonData).themeArea.manualDataIds.join();
				const _url = this.data[_key].NctvListApi +''+ this.data['Nctv'].NctvIds;

				axios.get( _url, {
					params: _param
				}).then((response) => {
					this.data['Nctv'].NctvList = response.data.data.content;
					_callback( this.data['Nctv'] );
					return this.data['Nctv'];
				}).catch((error, d) => {
					console.log( '! error : ', _key, d, error.response );
          if(window._serviceEnv == 'SB'){
            this.data['Nctv'].NctvList = nctvTestData
            _callback( this.data['Nctv'] );
            return this.data['Nctv'];
          }
				});


			}).catch( (error, d) => {
			  console.log( '! error : ', _key, d, error.response );
		  });
		}
	}
} // end of class
//SB, loval 테스트용
const shopTestData = {
  NshopRecommend:{
    "live": {
      "goodsList": [
    {
      "id": 414302,
      "name": "패스 레벨업 패키지",
      "basicSalePrice": 5000,
      "discountSalePrice": 5000,
      "goodsIconId": 0,
      "itemIds": [
        "84197",
        "84861"
      ],
      "items": [
        {
          "id": 84197,
          "name": "패스 레벨업",
          "level": 1,
          "grade": 5,
          "gradeName": "영웅",
          "sealed": false,
          "price": 1,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/potion_hphealandregenerate_10phase_5_1.png"
        },
        {
          "id": 84861,
          "name": "소울패스 특별 보상 선택 상자",
          "level": 1,
          "grade": 7,
          "gradeName": "전설",
          "sealed": false,
          "price": 1,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_event_skybox4_7_1.png"
        }
      ]
    },
    {
      "id": 414214,
      "name": "데이 데이 서포팅 패스 레벨업 (130개입)",
      "basicSalePrice": 5000,
      "discountSalePrice": 5000,
      "goodsIconId": 0,
      "itemIds": [
        "84904"
      ],
      "items": [
        {
          "id": 84904,
          "name": "데이 데이 서포팅 패스 레벨업",
          "level": 1,
          "grade": 5,
          "gradeName": "영웅",
          "sealed": false,
          "price": 1,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/event_grocery_potion_specialpass_03_5_1.png"
        }
      ]
    }
  ]
    }
  },
  NshopToday:{
    "live": {
      "goodsList": [
    {
      "id": 406457,
      "name": "홍문 두루마리",
      "basicSalePrice": 1500,
      "discountSalePrice": 1500,
      "goodsIconId": 0,
      "itemIds": [
        "82135"
      ],
      "items": [
        {
          "id": 82135,
          "name": "홍문 두루마리",
          "level": 1,
          "grade": 5,
          "gradeName": "영웅",
          "sealed": false,
          "price": 9,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_bmtalisman_hongmoon1_5_1.png"
        }
      ]
    },
    {
      "id": 412866,
      "name": "이글거리는 보화 상자",
      "basicSalePrice": 100,
      "discountSalePrice": 100,
      "goodsIconId": 1,
      "itemIds": [
        "829775",
        "829776",
        "829777",
        "829778"
      ],
      "items": [
        {
          "id": 829775,
          "name": "영석 결정",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 61,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/general_grocery_specialmaterial_1066_4_1.png"
        },
        {
          "id": 829776,
          "name": "월석 결정",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 70,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/quest_moonstone_4_1.png"
        },
        {
          "id": 829777,
          "name": "영단 결정",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 61,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/general_grocery_specialmaterial_1064_4_1.png"
        },
        {
          "id": 829778,
          "name": "선단 결정",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 70,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/general_grocery_specialmaterial_1065_4_1.png"
        }
      ]
    },
    {
      "id": 413112,
      "name": "거신의 심장 용봉주 (10개)",
      "basicSalePrice": 100,
      "discountSalePrice": 100,
      "goodsIconId": 0,
      "itemIds": [
        "934190"
      ],
      "items": [
        {
          "id": 934190,
          "name": "거신의 심장 용봉주",
          "level": 1,
          "grade": 5,
          "gradeName": "영웅",
          "sealed": false,
          "price": 378,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_food_specialalchol_01_5_1.png"
        }
      ]
    },
    {
      "id": 413129,
      "name": "[거신의 심장] 모래시계",
      "basicSalePrice": 200,
      "discountSalePrice": 200,
      "goodsIconId": 0,
      "itemIds": [
        "932440"
      ],
      "items": [
        {
          "id": 932440,
          "name": "[거신의 심장] 모래시계",
          "level": 1,
          "grade": 5,
          "gradeName": "영웅",
          "sealed": false,
          "price": 54,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_giantheart_potion_01_5_1.png"
        }
      ]
    },
    {
      "id": 413443,
      "name": "빛나는 의협단 쾌속 성장부적 (5개)",
      "basicSalePrice": 500,
      "discountSalePrice": 500,
      "goodsIconId": 0,
      "itemIds": [
        "82514"
      ],
      "items": [
        {
          "id": 82514,
          "name": "빛나는 의협단 쾌속 성장부적",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 74,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/produce_grocery_accountexptalisman_0001_4_1.png"
        }
      ]
    },
    {
      "id": 413823,
      "name": "진화석 (30개)",
      "basicSalePrice": 100,
      "discountSalePrice": 100,
      "goodsIconId": 0,
      "itemIds": [
        "820222"
      ],
      "items": [
        {
          "id": 820222,
          "name": "진화석",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 49,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_element_steel2_4_1.png"
        }
      ]
    },
    {
      "id": 413824,
      "name": "고귀한 보화 상자",
      "basicSalePrice": 300,
      "discountSalePrice": 300,
      "goodsIconId": 1,
      "itemIds": [
        "820005",
        "827513",
        "810603",
        "820004"
      ],
      "items": [
        {
          "id": 820005,
          "name": "월석",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 70,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_moonstone_4_1.png"
        },
        {
          "id": 827513,
          "name": "선단",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 70,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/general_grocery_specialmaterial_1043_4_1.png"
        },
        {
          "id": 810603,
          "name": "영석",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 61,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/gather_shiny_gemstone_4_1.png"
        },
        {
          "id": 820004,
          "name": "영단",
          "level": 1,
          "grade": 4,
          "gradeName": "최상급",
          "sealed": false,
          "price": 61,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/general_grocery_specialmaterial_1042_4_1.png"
        }
      ]
    },
    {
      "id": 413998,
      "name": "풍도석 결정 (50개)",
      "basicSalePrice": 200,
      "discountSalePrice": 200,
      "goodsIconId": 0,
      "itemIds": [
        "934570"
      ],
      "items": [
        {
          "id": 934570,
          "name": "풍도석 결정",
          "level": 1,
          "grade": 7,
          "gradeName": "전설",
          "sealed": false,
          "price": 61,
          "type": "grocery",
          "icon": "https://assets.playnccdn.com/gamedata/powerbook/bns/ui_resource/grocery/grocery_tm4_upgradestone_02_7_1.png"
        }
      ]
    }
  ],
      "remainTime": {
    "hour": 3,
      "minute": 56
  }
    }
  },
  NshopMygodstone:{
    "count": 0
  }
};
const nctvTestData = [
  {
    "id": 63726,
    "videoKind": "OFFICIAL",
    "provider": "youtube",
    "providerVideoId": "L21EyBytnVs",
    "gameCode": 2,
    "gameAlias": "bns",
    "providerChannelId": "UC15smwTxAxbhsyqJm89TDKQ",
    "title": "[B&S] 블레이드 & 소울 – 신규 클래스 '쌍검사' 시네마틱 트레일러",
    "videoType": "vod",
    "liveStatus": "none",
    "playtime": 106,
    "thumbnail": "https://i.ytimg.com/vi/L21EyBytnVs/maxresdefault.jpg",
    "providerVideoUrl": "https://www.youtube.com/watch?v=L21EyBytnVs",
    "mainExposedCount": 0,
    "createDate": "1623424321000",
    "updateDate": "1630613261000",
    "viewCount": 0,
    "likeCount": 0,
    "providerCurrentViewCount": 0,
    "providerTotalViewCount": 37329,
    "providerLikeCount": 346,
    "channelId": 1,
    "channelKind": "nctv",
    "channelName": "plaync",
    "channelAlias": "bns",
    "channelThumbnail": "https://yt3.ggpht.com/dVkFw4hDExufqbw8Z42XCnq5mH-Dga3QEp4ut5wKYSlDoigt2-_1ypFtlj8ayWFWs0rBf1m4rA=s88-c-k-c0x00ffffff-no-rj",
    "zone": {},
    "talkpickCount": 0,
    "ncstreaming": false
  },
  {
    "id": 63724,
    "videoKind": "OFFICIAL",
    "provider": "youtube",
    "providerVideoId": "67G6y3w96iQ",
    "gameCode": 2,
    "gameAlias": "bns",
    "providerChannelId": "UC15smwTxAxbhsyqJm89TDKQ",
    "title": "[B&S] 블레이드 & 소울 ‘태동 업데이트 – 쌍검사 & 천공의 유랑선’ 소개 영상",
    "videoType": "vod",
    "liveStatus": "none",
    "playtime": 92,
    "thumbnail": "https://i.ytimg.com/vi/67G6y3w96iQ/maxresdefault.jpg",
    "providerVideoUrl": "https://www.youtube.com/watch?v=67G6y3w96iQ",
    "mainExposedCount": 0,
    "createDate": "1624644991000",
    "updateDate": "1646673207000",
    "viewCount": 7,
    "likeCount": 0,
    "providerCurrentViewCount": 0,
    "providerTotalViewCount": 19706,
    "providerLikeCount": 179,
    "channelId": 1,
    "channelKind": "nctv",
    "channelName": "plaync",
    "channelAlias": "bns",
    "channelThumbnail": "https://yt3.ggpht.com/dVkFw4hDExufqbw8Z42XCnq5mH-Dga3QEp4ut5wKYSlDoigt2-_1ypFtlj8ayWFWs0rBf1m4rA=s88-c-k-c0x00ffffff-no-rj",
    "zone": {},
    "talkpickCount": 0,
    "ncstreaming": false
  },
  {
    "id": 154779,
    "videoKind": "OFFICIAL",
    "provider": "youtube",
    "providerVideoId": "I_l1gMM4DtM",
    "gameCode": 2,
    "gameAlias": "bns",
    "providerChannelId": "UC15smwTxAxbhsyqJm89TDKQ",
    "title": "[B&S] 블레이드 & 소울 – 에픽 12막 ‘북녘의 붉은 달’ 시네마틱 트레일러",
    "videoType": "vod",
    "liveStatus": "none",
    "playtime": 90,
    "thumbnail": "https://i.ytimg.com/vi/I_l1gMM4DtM/maxresdefault.jpg",
    "providerVideoUrl": "https://www.youtube.com/watch?v=I_l1gMM4DtM",
    "mainExposedCount": 0,
    "createDate": "1666141559000",
    "updateDate": "1676368721000",
    "viewCount": 2273,
    "likeCount": 0,
    "providerCurrentViewCount": 0,
    "providerTotalViewCount": 7279,
    "providerLikeCount": 96,
    "channelId": 2470,
    "channelKind": "nctv",
    "channelName": "plaync",
    "channelAlias": "bns",
    "channelThumbnail": "https://yt3.ggpht.com/dVkFw4hDExufqbw8Z42XCnq5mH-Dga3QEp4ut5wKYSlDoigt2-_1ypFtlj8ayWFWs0rBf1m4rA=s88-c-k-c0x00ffffff-no-rj",
    "zone": {},
    "talkpickCount": 0,
    "ncstreaming": false
  }
];
export default DataStore;